var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#FF8C2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7143 12H15.2857C14.4214 12 13.7143 12.7071 13.7143 13.5714V26.1429C13.7143 27.0071 14.4214 27.7143 15.2857 27.7143H24.7143C25.5786 27.7143 26.2857 27.0071 26.2857 26.1429V13.5714C26.2857 12.7071 25.5786 12 24.7143 12ZM24.7143 25.0351L21.8935 22.2143L23.1428 20.965L24.7142 22.5364L24.7143 25.0351ZM24.7143 13.5714V20.3208L23.7007 19.3072C23.3943 19.0008 22.8993 19.0008 22.5929 19.3072L20.7936 21.1065L18.2087 18.5216C17.9022 18.2151 17.4073 18.2151 17.1008 18.5216L15.3016 20.3208V13.5715H24.7301L24.7143 13.5714ZM15.2857 22.5364L17.6429 20.1792L23.6065 26.1429H15.2857V22.5364Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5714 12H9.78571C9.35356 12 9 12.3536 9 12.7857C9 13.2179 9.35356 13.5714 9.78571 13.5714H10.5714V26.1429H9.78571C9.35356 26.1429 9 26.4964 9 26.9286C9 27.3607 9.35356 27.7143 9.78571 27.7143H10.5714C11.4357 27.7143 12.1429 27.0071 12.1429 26.1429V13.5714C12.1429 12.7071 11.4357 12 10.5714 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2143 26.1429H29.4285V13.5714H30.2143C30.6464 13.5714 31 13.2179 31 12.7857C31 12.3536 30.6464 12 30.2143 12H29.4285C28.5643 12 27.8571 12.7071 27.8571 13.5714V26.1429C27.8571 27.0071 28.5643 27.7143 29.4285 27.7143H30.2143C30.6464 27.7143 31 27.3607 31 26.9286C31 26.4964 30.6464 26.1429 30.2143 26.1429Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3571 16.3215C22.3571 17.8929 20 17.8929 20 16.3215C20 14.7501 22.3571 14.7501 22.3571 16.3215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGallery);
export default __webpack_public_path__ + "static/media/ic_Gallery.be074fe1bda413352390a1f7bcfd5e3f.svg";
export { ForwardRef as ReactComponent };